import React, { Component } from 'react';
import { NavLink } from 'reactstrap';
import {  Row, Col } from 'reactstrap';
import { Link } from 'react-router-dom';
export class Home extends Component {
    static displayName = Home.name;

    constructor(props) {
        super(props);
        this.state = { branches: [], loading: true };
    }

    componentDidMount() {
        this.populateBranchData();
    }

    static renderBranchTable(branches) {
        return (
            <div className="card-columns ">
                <div>
                    <div className="card text-white bg-success text-center">
                        <div className="card-body">
                            <h5 className="card-title"><NavLink tag={Link} className="text-dark" to={"/Order/Job/Large"}>Job</NavLink></h5>
                        </div>
                    </div>
                </div>
                <div>
                    <div className="card text-white bg-success text-center">
                        <div className="card-body">
                            <h5 className="card-title"><NavLink tag={Link} className="text-dark" to={"/Order/Engineering"}>Engineering</NavLink></h5>
                        </div>
                    </div>
                </div>

                {branches.map(branch => 
                    <div>
                        <div className="card text-white bg-danger text-center" >
                            <div className="card-body">
                                <h5 className="card-title"><NavLink tag={Link} className="text-dark" to={`/Order/${branch.name}/${branch.size}`}>{branch.name}</NavLink></h5>
                            </div>
                        </div>
                    </div>
                )}
                
            </div>
        );
    }

    render() {

        let contents = this.state.loading ? <p><em>Loading...</em></p> : Home.renderBranchTable(this.state.branches);

        return (
            <div>
                <h1>Select an option to place an order for: </h1>
                {contents}
            </div>
        );
    }

    async populateBranchData() {

        const response = await fetch('branches');
        const data = await response.json();
        this.setState({ branches: data, loading: false });
    }

}
